import React from 'react';
import PropTypes from 'prop-types';
import CustomPageDetailContentWrapper from './CustomPageDetailContentWrapper';

const CustomPageDetailContentFreeText = (props) => {

  let {
    pageBlock,
  }= props;

  return (
    <CustomPageDetailContentWrapper pageBlock={pageBlock} />
  );
}

CustomPageDetailContentFreeText.propTypes = {
  pageBlock: PropTypes.any.isRequired
};

export default CustomPageDetailContentFreeText;
